<template>
  <div>
    <div class="login" >
      <div style="padding:20px;
    text-align: left;
    display: flex;
    align-items: center;font-weight:bold;"  @click='goback'>
        <mu-icon value='arrow_back'></mu-icon>
        {{this.$route.params.symbolName}}
        </div>
      <dl class="user-title">
       
        <dd > 短讯验证码</dd>
        

      </dl>


      <div class="user-form">
        
         <mu-text-field max-length=6 full-width v-model="vcode" placeholder="请输入短讯验证码"> </mu-text-field>
        
          <br>
          <mu-button color="primary" :disabled="vcode.length!=6" full-width @click="nextStep">下一步</mu-button>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
    data(){
      return {
        vcode:'',
      }
    },
    methods:{
        toLogin(){
            this.$router.push("/login")
        },
        goback(){
          this.$router.go(-1);
        },
        nextStep(){
          this.$store.state.vcode=this.vcode;
          this.$router.push("/passwordset")
        }
    }
};
</script>

<style scoped>
  .user-top{
      display: flex;
      justify-content: flex-end;
      padding-top:10px;
     
  }
  .user-title{
      padding:40px 20px;
      width: 80%;
      text-align: left;
      font-size: 2rem;
  }
  .user-form{
      display: flex;
       padding: 20px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
  }
  .myinput {
      height:50px;
      width: 80%;
      border: gray;
  }
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/VPhone.vue